export default {
    
      setFooter(state, footer) {
        state.footer = footer;
      },
      setTitle(state, value) {
        state.title = value;
        document.title = (state.title ? state.title + ' - ' : '') + `${rtwp.site_name} - ${rtwp.tagline}`;
      },
      setCurrent(state, id) {
        state.current = id;
      },
      setPost(state, post) {
        state.post = post;
      },
      setComment(state, comment) {
        state.comment = comment;
      },
      setThreadComment(state, comment) {
        state.threadComment = comment;
      },
      setPosts(state, posts) {
        state.posts = {...posts}
      },
      setComments(state, comments) {
        state.comments = comments;
      },
      setThreadComments(state, comments) {
        state.threadComments = comments;
      },
      setTwoReplies(state, comments) {
        state.firstTwoReplies = comments;
      },
      setPostsByCategory(state, posts) {
        state.postsByCategory = {...state.postsByCategory, ...posts};
      },
      setPostsByAuthor(state, posts) {
        state.postsByAuthor = {...state.postsByAuthor, ...posts};
      },
      setRelatedPosts(state, posts) {
        state.relatedPosts = {...posts};
      },
      setCurrentCategory(state, name) {
        state.currentCategory = name;
      },
      setCurrentSlideNumber(state, number) {
        state.currentSlide = number;
      },
      setHero(state, hero) {
        state.hero = {...state.hero, ...hero};
      },
      setThemeColor(state, color) {
        state.themeColor = color;
      },
      setHasComments(state, hasComments) {
        state.hasComments = hasComments;
      },
      setHeroAndNavigate(state, hero) {
        let index = state.hero.slides.findIndex((slide) => slide.id === hero.slide.id)
        if (index <= -1) {
          state.hero.slides.splice(state.currentSlide + 1, 0, hero.slide);
          index = state.currentSlide + 1;
        }
        state.hero.navigateTo = index;
        state.hero.slide = hero.slide;
        state.hero.hideTitle = false;
      }
}